import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';
import { widthPercentageToDP } from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flexDirection: 'row',
        marginLeft: widthPercentageToDP(16, 44, 72),
        marginBottom: 20,
    },
    seasonTab: {
        paddingHorizontal: 18,
        paddingVertical: 8,
        borderBottomWidth: 3,
        borderBottomColor: lightGrey(0.5),
    },
    seasonTabActive: {
        borderBottomColor: lightGrey(1),
    },
    seasonTabTitle: {
        fontFamily: Fonts.main.bold,
        fontSize: 16,
        color: lightGrey(0.7),
    },
    seasonTabTitleActive: {
        color: lightGrey(1),
    },
});

export default styles;
